// extracted by mini-css-extract-plugin
export default {"content":"Simulacao_content__YUXip","section":"Simulacao_section__N0mr1","cardsContainer":"Simulacao_cardsContainer__ukexS"};